export default {"src":"/_next/static/media/navigate-circle-color.12ca3c93.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};